import { render, staticRenderFns } from "./groceryBagBlock.vue?vue&type=template&id=4c300d04&"
import script from "./groceryBagBlock.vue?vue&type=script&lang=js&"
export * from "./groceryBagBlock.vue?vue&type=script&lang=js&"
import style0 from "./groceryBagBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports